import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"

import "./List.vue?vue&type=style&index=0&id=44fd63c5&lang=less&scoped=true"
script.__scopeId = "data-v-44fd63c5"

export default script